import Link from "next/link";

export function PublicLegalFooter(): JSX.Element {
  return (
    <nav
      aria-label="Liens juridiques Bookifull"
      className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm">
      <Link className="text-subtle hover:text-emphasis hover:underline" href="/privacy">
        Confidentialité
      </Link>
      <Link className="text-subtle hover:text-emphasis hover:underline" href="/terms">
        Conditions d’utilisation
      </Link>
    </nav>
  );
}
